import React from 'react';
import { Outlet } from 'react-router-dom';
import './VendorLayout.css';

const VendorLayout = () => {
  return (
    <div className="vendor-layout">
      {/* No header/navigation for vendor pages */}
      <Outlet />
    </div>
  );
};

export default VendorLayout; 